import { SearchDisplayMode, SearchType } from "./types/TCanvasOptions";

export const DOMAIN_NODE_SIZE = 40;
export const TABLE_NODE_SIZE = 22;
export const COLUMN_NODE_SIZE = 14;

export const DOMAIN_TEXT_OFFSET = 35;
export const TABLE_TEXT_OFFSET = 38;
export const COLUMN_TEXT_OFFSET = 27;

export const DOMAIN_TEXT_SIZE = 16;
export const TABLE_TEXT_SIZE = 18;
export const COLUMN_TEXT_SIZE = 12;

export const DOMAIN_SHADOW_WIDTH = 8;
export const TABLE_SHADOW_WIDTH = 6;
export const COLUMN_SHADOW_WIDTH = 20;

export const DOMAIN_TEXT_LIMIT = 2000
export const TABLE_TEXT_LIMIT = 400
export const COLUMN_TEXT_LIMIT = 100


// SEARCH OPTIONS
export const SEARCH_TYPE = SearchType.NORMAL
export const SEARCH_DISPLAY_MODE = SearchDisplayMode.FILTER

export const DEFAULT_ACCURACY_RANGE = [80, 100]
export const DEFAULT_ACCURACY_STEP = 10
export const DEFAULT_ACCURACT_MIN = 0
export const DEFAULT_ACCURACY_MAX = 100

export const ACCURACY = {
  "high": [90, 100],
  "medium": [70, 89],
  "low": [0, 69]
}

export const DEFAULT_SEARCH_TEXT = ""
export const DEFAULT_GRANULARITY = 2
export const DEFAULT_SHOW_DQ_TOGGLE = false

// LINK
export const HEIRARCHICAL_LINK_WIDTH = 0.1
export const HEIRARCHICAL_LINK_COLOR = "gray"

export const FOREIGN_LINK_SIZE = 8;
export const FOREIGN_LINK_BORDER = 1;
export const FOREIGN_LINK_COLOR = "gray";
export const FOREIGN_LINK_NODE_SHADOW = 6

export const FOREIGN_LINK_DISABLED_SIZE = 4;
export const FOREIGN_LINK_DISABLED_COLOR = "lightgray"
